export default {
  meta: {
    name: '详情',
    title: '需求详情',
    crumbs: { // 面包屑群组，必须同时带上 path 和 name 参数
      path: ['/'],
      name: ['选址需求']
    }
  }
};
